import { render, staticRenderFns } from "./AssessmentView.vue?vue&type=template&id=6436046c&scoped=true&"
import script from "./AssessmentView.vue?vue&type=script&lang=js&"
export * from "./AssessmentView.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentView.vue?vue&type=style&index=0&id=6436046c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6436046c",
  null
  
)

export default component.exports